/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * コード値変換マスターテーブル（OT_THZTCDH）のキャッシュ値
 */
export interface CodeValueTransCacheDto { 
    /**
     * 変換元１コード
     */
    convertBeforeSource1Code?: string;
    /**
     * 変換元１テキスト
     */
    convertBeforeSource1Text?: string;
    /**
     * 変換元２コード
     */
    convertBeforeSource2Code?: string;
    /**
     * 変換元２テキスト
     */
    convertBeforeSource2Text?: string;
    /**
     * 変換元３コード
     */
    convertBeforeSource3Code?: string;
    /**
     * 変換元３テキスト
     */
    convertBeforeSource3Text?: string;
    /**
     * 変換後１コード
     */
    convertAfterSource1Code?: string;
    /**
     * 変換後１テキスト
     */
    convertAfterSource1Text?: string;
    /**
     * 変換後２コード
     */
    convertAfterSource2Code?: string;
    /**
     * 変換後２テキスト
     */
    convertAfterSource2Text?: string;
    /**
     * 変換後３コード
     */
    convertAfterSource3Code?: string;
    /**
     * 変換後３テキスト
     */
    convertAfterSource3Text?: string;
}

